class DirtyWall {
  constructor(section) {
    this.section = section;
    this.cards = Array.from(section.querySelectorAll('.dirty-wall__card'));
    this.modal = section.querySelector('.dirty-wall-modal');

    if (!this.modal || this.cards.length === 0) return;

    this.image = this.modal.querySelector('.dirty-wall-modal__image');
    this.name = this.modal.querySelector('.dirty-wall-modal__name');
    this.band = this.modal.querySelector('.dirty-wall-modal__band');
    this.quote = this.modal.querySelector('.dirty-wall-modal__quote');
    this.pedal = this.modal.querySelector('.dirty-wall-modal__pedal');

    this.closeButtons = this.modal.querySelectorAll('[data-dirty-wall-close]');
    this.previousButton = this.modal.querySelector('[data-dirty-wall-previous]');
    this.nextButton = this.modal.querySelector('[data-dirty-wall-next]');

    this.currentIndex = 0;
    this.previouslyFocusedElement = null;

    this.bindEvents();
  }

  bindEvents() {
    this.cards.forEach((card, index) => {
      card.addEventListener('click', () => this.open(index));

      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.open(index);
        }
      });
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.previousButton?.addEventListener('click', () => {
      this.showPrevious();
    });

    this.nextButton?.addEventListener('click', () => {
      this.showNext();
    });

    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!this.modal.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        this.close();
      }

      if (event.key === 'ArrowLeft') {
        this.showPrevious();
      }

      if (event.key === 'ArrowRight') {
        this.showNext();
      }
    });
  }

  open(index) {
    this.previouslyFocusedElement = document.activeElement;
    this.currentIndex = index;

    this.updateContent();

    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dirty-wall-modal-open');

    const closeButton = this.modal.querySelector('.dirty-wall-modal__close');
    closeButton?.focus();
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dirty-wall-modal-open');

    this.previouslyFocusedElement?.focus();
  }

  showPrevious() {
    this.currentIndex =
      (this.currentIndex - 1 + this.cards.length) % this.cards.length;

    this.updateContent();
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.cards.length;

    this.updateContent();
  }

  updateContent() {
    const card = this.cards[this.currentIndex];

    const image = card.dataset.image || '';
    const imageAlt = card.dataset.imageAlt || card.dataset.name || '';
    const name = card.dataset.name || '';
    const band = card.dataset.band || '';
    const quote = card.dataset.quote || '';
    const pedal = card.dataset.pedal || '';

    if (this.image) {
      this.image.src = image;
      this.image.alt = imageAlt;
    }

    if (this.name) {
      this.name.textContent = name;
    }

    if (this.band) {
      this.band.textContent = band;
      this.band.hidden = band === '';
    }

    if (this.quote) {
      this.quote.textContent = quote;
      this.quote.hidden = quote === '';
    }

    if (this.pedal) {
      this.pedal.textContent = pedal;
      this.pedal.hidden = pedal === '';
    }
  }
}

function initializeDirtyWalls(container = document) {
  container.querySelectorAll('[data-dirty-wall]').forEach((section) => {
    if (section.dataset.dirtyWallInitialized === 'true') return;

    section.dataset.dirtyWallInitialized = 'true';
    new DirtyWall(section);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeDirtyWalls();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeDirtyWalls(event.target);
});